// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';

import '../styles/default.css';
import '../styles/navigation.css';

export default class DefaultNav extends React.Component {

    render = () => {
        return (<>
        
            <div className="navigation-logo default-nav-logo">
                <img
                    src="https://static.stax.ai/images/logo/color.svg"
                    alt="[Stax·ai Logo]"
                />STAX<div className="navigation-logo-dot"></div>AI
                {/* <div className="navigation-logo-beta">BETA</div> */}
            </div>

        </>);
    }

}